import React, { useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import hero1 from "../assets/TIG Website Images/Contact Us/tig.jpg";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/home.css";
const Contact = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_108fu8k", "template_uz20f6d", form.current, {
        publicKey: "dSxES0gVKjdpWLqFr",
      })
      .then(
        () => {
          alert("SUCCESS!");
          form.current.reset(); //Reset form after successful send
        },
        (error) => {
          alert("FAILED...", error.text);
        }
      );
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid p-0">
        <div
          className="hero-section"
          style={{ backgroundImage: `url(${hero1})` }}
        >
          <div
            className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100"
            data-aos="zoom-in"
          >
            <div className="col-lg-10 zoom-in-text">
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                Contact Us
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Info Section */}
      <section className="pt-5 pb-2 bg-white">
        <div className="container-fluid px-3 px-md-5">
          {/* Title */}
          <div className="text-center mb-5" data-aos="fade-up">
            <h6 className="text-primary text-uppercase fw-bold">Contact Us</h6>
            <h2 className="fw-bold">
              If You Have Any Query, Feel <br /> Free To Contact Us
            </h2>
          </div>

          {/* Contact Info Row */}
          <Row className="g-4">
            {/* Phone */}
            <Col lg={3} md={6} sm={12} data-aos="fade-up">
              <div className="d-flex align-items-center p-3 h-100 shadow-sm rounded bg-light">
                <div
                  className="contact-box rounded d-flex align-items-center justify-content-center me-3"
                  style={{ width: "60px", height: "60px" }}
                >
                  <FaPhoneAlt size={24} />
                </div>
                <div>
                  <h6 className="mb-1">Call to ask any question</h6>
                  <a
                    href="tel:99882340"
                    className="text-decoration-none text-primary fw-semibold"
                  >
                    +968 2284 2089
                  </a>
                </div>
              </div>
            </Col>

            {/* Email */}
            <Col lg={4} md={6} sm={12} data-aos="fade-up">
              <div className="d-flex align-items-center p-3 h-100 shadow-sm rounded bg-light">
                <div
                  className="contact-box rounded d-flex align-items-center justify-content-center me-3"
                  style={{ width: "60px", height: "60px" }}
                >
                  <FaEnvelope size={24} />
                </div>
                <div>
                  <h6 className="mb-1">Email to get free quote</h6>
                  <a
                    href="mailto:ahmed@tig-oman.com"
                    className="text-decoration-none text-primary fw-semibold"
                  >
                    info@tig-oman.com
                  </a>
                </div>
              </div>
            </Col>

            {/* Address */}
            <Col lg={5} md={12} sm={12} data-aos="fade-up">
              <div className="d-flex align-items-start p-3 h-100 shadow-sm rounded bg-light">
                <div
                  className="contact-box rounded d-flex align-items-center justify-content-center me-3"
                  style={{ width: "120px", height: "60px" }}
                >
                  <FaMapMarkerAlt size={24} />
                </div>
                <div>
                  <h6 className="mb-1">Visit Our Office</h6>
                  <p className="mb-0 text-primary fw-semibold">
                    Tower International Group, LLC, Office 204, 2nd Floor, Al
                    Assalah Towers, Muscat, Sultanate of Oman
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Form */}
      <section className="py-2">
        <div className="container-fluid px-3 px-md-5">
          <Row className="align-items-center">
            {/* Left Side - Form */}
            <Col md={6} className="mb-4 mt-5" data-aos="fade-up">
              <Form ref={form} onSubmit={sendEmail}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Your Name"
                    name="name" //  Must match EmailJS template variable
                    className="custom-input"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Your Email"
                    name="email" // Must match EmailJS template variable
                    className="custom-input"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Subject"
                    name="subject" // Add subject variable in EmailJS template
                    className="custom-input"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Message"
                    name="message" // Must match EmailJS template variable
                    className="custom-input"
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="custom-btn">
                  Submit
                </Button>
              </Form>
            </Col>

            {/*  - Map */}
            <Col md={6} data-aos="fade-up">
              <div
                style={{
                  height: "350px",
                  width: "100%",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
               <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.6324483710346!2d58.3979431!3d23.5816407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ff19b8247351%3A0xd5b578337f73c6db!2sTIG%20(Towers%20International%20Group%20of%20Companies)!5e0!3m2!1sen!2sin!4v1763457995185!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default Contact;
